import { OpenFeature } from "@openfeature/react-sdk";
import flags from "../features/featureFlags/flags";

/**
 * Check if Salesforce integration is enabled via feature flag
 * @returns {boolean} true if Salesforce is enabled, false otherwise
 */
export const isSalesforceEnabled = () => {
  // const client = OpenFeature.getClient();
  // return client.getBooleanValue(flags.SALESFORCE_ENABLED, false);
  return true;
};
/**
 * Check if Subscribe integration is enabled via feature flag
 * @returns {boolean} true if Subscribe is enabled, false otherwise
 */
export const isSubscribeEnabled = () => {
  const client = OpenFeature.getClient();
  return client.getBooleanValue(flags.SUBSCRIBE_ENABLED, false);
};

/**
 * Get the API provider based on Salesforce flag
 * @returns {string} 'salesforce' or 'dataverse'
 */
export const getApiProvider = () => {
  return isSalesforceEnabled() ? "salesforce" : "dataverse";
};
